var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-danger",staticStyle:{"font-size":"14px","color":"red","margin":"0px"},domProps:{"innerHTML":_vm._s(_vm.error)}})}
var staticRenderFns = []

export { render, staticRenderFns }